import { AppData, GetAllRequestResponse } from "../../types";
import { getRequestWrapper } from "../../utilities";

export type getAppsResponse = GetAllRequestResponse<never, AppData>;

export function getApps(): Promise<getAppsResponse> {
  return getRequestWrapper<never, getAppsResponse>({
    url: `${ENV_SETTINGS.API_URL}/apps`,
  });
}
